import moment from 'moment'
import { statesList } from './us-states'

const today = new Date()

export function getNumberOfDaysFromToday(date) {
  const a = moment(today)
  const b = moment(date)
  return b.diff(a, 'days') + 1
}

export function isDateOnWeekend(date) {
  console.log(date.getDay())
}

export function selectDropdownLabel(option, id) {
  if (id !== undefined && id === 'multilingualIndicator') {
    return option ? 'Spanish and English' : 'English Only'
  } else if (typeof (option) === 'boolean') {
    return option ? 'Yes' : 'No'
  } else if (option === undefined) {
    return 'Select Option'
  } else {
    for (const property in statesList) {
      if (property === option) return statesList[option]
    }
    return option
  }
}

export function convertBooleanToYn(property) {
  return property ? 'Y' : 'N'
}

export function isObjectTheSame(a, b) {
  const aProps = Object.getOwnPropertyNames(a)
  const bProps = Object.getOwnPropertyNames(b)

  if (aProps.length !== bProps.length) return false

  for (var i = 0; i < aProps.length; i++) {
    const propName = aProps[i]
    if (a[propName] !== b[propName]) return false
  }

  return true
}

export function copyObject(mainObj) {
  let objCopy = {}
  let key

  for (key in mainObj) objCopy[key] = mainObj[key]
  return objCopy
}

export function displayString(value) {
  return value || ''
}

export function getEventTypeDescription(value) {
  // NOTE: General Wellness (1), or Open Enrollment (2), or General Wellness and Presentation Needed (3)
  if (value == 1) return 'General Wellness'
  else if (value == 2) return 'Open Enrollment'
  else return 'General Wellness, Presentation Needed'
}

export function getRequestTypeDescription(benefitIndicator, digitalIndicator, materialsIndicator, standardIndicator) {
  if (standardIndicator == 'Y') return 'On-Site/Virtual Representative'
  else if (materialsIndicator == 'Y') return 'Printed Materials'
  else if (digitalIndicator == 'Y') return 'Digital Booth & Tools'
  else if (benefitIndicator == 'Y') return 'Benefit Summary'
  else return standardIndicator
}

export function getEditableItemIndex(event) {
  return new Promise((resolve, reject) => {
    const rows = document.querySelectorAll('#location-table table tr')
    const rowsArray = Array.from(rows)
    const i = rowsArray.findIndex(row => row.contains(event.target)) - 2
    resolve(i)
  })
}
